module.exports = __webpack_public_path__ + "static/media/game-press-symbol-education.71cbd005.png";